module.exports = __webpack_public_path__ + "static/media/dietary_restrictions.2429e259.svg";